<template>
  <se-message-bubble position="left">
    <p class="italic text-neutral-60">
      typing
      <se-jumping-dots/>
    </p>
  </se-message-bubble>
</template>

<script setup lang="ts">
import SeMessageBubble from "@/src/shared/ui-kit/message-bubble/MessageBubble.vue";
import SeJumpingDots from "@/src/components/JumpingDots.vue";
</script>

<script lang="ts">
export default {
  name: 'SeTypingBubble',
};
</script>

<style scoped lang="scss">

</style>